module.exports = __webpack_public_path__ + "files/src/assets/files/new-certs/Декларация о соответствии Щебень 5-20,20-40,40-70.pdf";